import { render, staticRenderFns } from "./workerEdit.vue?vue&type=template&id=627be4cb&"
import script from "./workerEdit.vue?vue&type=script&lang=js&"
export * from "./workerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports